/**
 * Owner: Masa Bayu
 * File: codes.ts
 * Date:Time: 2026-09-18 15:50
 * Description: Locked vocabulary for Document IR source types, blocks, and confidence.
 */

export const QX_DOCUMENT_IR_MODEL_VERSION = '1.0.0' as const;

export const QX_DOCUMENT_SOURCE_TYPES = [
  'pdf',
  'docx',
  'pptx',
  'xlsx',
  'odt',
  'rtf',
  'epub',
  'html',
  'txt',
  'md',
  'image',
  'other',
] as const;
export type QXDocumentSourceType = (typeof QX_DOCUMENT_SOURCE_TYPES)[number];

export const QX_DOCUMENT_BLOCK_TYPES = [
  'DOCUMENT',
  'SECTION',
  'CHAPTER',
  'PART',
  'HEADING',
  'SUBHEADING',
  'PARAGRAPH',
  'QUOTE',
  'CALLOUT',
  'LIST',
  'LIST_ITEM',
  'TABLE',
  'TABLE_ROW',
  'TABLE_CELL',
  'FIGURE',
  'IMAGE',
  'CAPTION',
  'FOOTNOTE',
  'ENDNOTE',
  'REFERENCE',
  'CODE',
  'EQUATION',
  'FORMULA',
  'POETRY',
  'VERSE',
  'PAGE_BREAK',
  'HEADER',
  'FOOTER',
  'PAGE_NUMBER',
  'SEPARATOR',
  'EMBED',
  'LINK',
] as const;
export type QXDocumentBlockType = (typeof QX_DOCUMENT_BLOCK_TYPES)[number];

export const QX_DOCUMENT_CONFIDENCE_TARGETS = [
  'ocr',
  'reading-order',
  'heading',
  'chapter',
  'table',
  'caption',
  'figure',
  'semantic-type',
  'metadata',
] as const;
export type QXDocumentConfidenceTarget = (typeof QX_DOCUMENT_CONFIDENCE_TARGETS)[number];

export const QX_DOCUMENT_WARNING_SEVERITIES = ['INFO', 'WARNING', 'ERROR', 'BLOCKER'] as const;
export type QXDocumentWarningSeverity = (typeof QX_DOCUMENT_WARNING_SEVERITIES)[number];

export const QX_DOCUMENT_METADATA_SOURCES = [
  'source',
  'extracted',
  'inferred',
  'publisher',
] as const;
export type QXDocumentMetadataSource = (typeof QX_DOCUMENT_METADATA_SOURCES)[number];

export const QX_DOCUMENT_DIRECTIONS = ['ltr', 'rtl', 'mixed'] as const;
export type QXDocumentDirection = (typeof QX_DOCUMENT_DIRECTIONS)[number];

export const QX_DOCUMENT_ASSET_KINDS = ['image', 'font', 'media', 'other'] as const;
export type QXDocumentAssetKind = (typeof QX_DOCUMENT_ASSET_KINDS)[number];

export const QX_DOCUMENT_REVIEW_CONFIDENCE_THRESHOLD = 0.8 as const;

export function isQXDocumentSourceType(value: unknown): value is QXDocumentSourceType {
  return (
    typeof value === 'string' && (QX_DOCUMENT_SOURCE_TYPES as readonly string[]).includes(value)
  );
}

export function isQXDocumentBlockType(value: unknown): value is QXDocumentBlockType {
  return (
    typeof value === 'string' && (QX_DOCUMENT_BLOCK_TYPES as readonly string[]).includes(value)
  );
}
